// AUTOGENERATED FILE - DO NOT MODIFY!
// This file was generated by Djinni from 003_fatmap_api_camera.djinni
export var CameraViewType;
(function (CameraViewType) {
    /**
     * Camera view type that limits the the camera to be looking down and user
     * gestures that would tilt the camera are prevented/blocked. All flyTo
     * methods that can take the camera's tilt (or pitch) as an argument also
     * force the camera to look down. Calling flyThrough, flyover or
     * enterFirstPersonView will exit this mode, but it isn't the recommended way
     * of changing the camera view type. The terrain is also flattened in this
     * mode to prevent parallax effect.
     */
    CameraViewType[CameraViewType["CAMERA2D"] = 0] = "CAMERA2D";
    /**
     * The default camera view type where there are no constraints on gestures
     * that control the camera, the terrain is in 3D and all of the camera APIs
     * behave as expected.
     */
    CameraViewType[CameraViewType["CAMERA3D"] = 1] = "CAMERA3D";
})(CameraViewType || (CameraViewType = {}));
/** Represents different camera states to observe */
export var CameraStateFlags;
(function (CameraStateFlags) {
    CameraStateFlags[CameraStateFlags["VIEW_TYPE"] = 1] = "VIEW_TYPE";
    CameraStateFlags[CameraStateFlags["TARGET"] = 2] = "TARGET";
    CameraStateFlags[CameraStateFlags["ALL"] = 3] = "ALL";
})(CameraStateFlags || (CameraStateFlags = {}));
